define( function() {
	"use strict";

	return ( /^$|\/(?:java|ecma)script/i );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/manipulation/var/rscriptType.js
// module id = 53
// module chunks = 0